var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.message)?_c('span',[_c('div',{staticClass:"message-text",staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.message))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }